export default __webpack_public_path__ + "static/pittas-b164ef4569b745046457261b8f4bfa8e.jpg";